import { registerPlugin } from '@capacitor/core';

import type { JsonFileExporterPlugin } from './definitions';

const JsonFileExporter = registerPlugin<JsonFileExporterPlugin>('JsonFileExporter', {
  web: () => import('./web').then(m => new m.JsonFileExporterWeb()),
});

export * from './definitions';
export { JsonFileExporter };
